import React from "react";
import { deltaText } from "./derive.js";

/**
 * Every delta on the page renders through here, so the three panes and the
 * mover list can never disagree about what "+8.1%" means or how a decrease is
 * coloured.
 *
 * Returns null — not an empty span — when comparison is off, so the layout
 * does not reserve space for a value that will never appear.
 */
export default function Delta({ current, previous, compare }) {
  if (!compare) return null;
  const d = deltaText(current, previous);
  if (!d) return null;
  const cls = d.direction === "up" ? " delta-inline-up" : d.direction === "down" ? " delta-inline-down" : "";
  return <span className={`delta-inline${cls}`}>{d.text}</span>;
}
